import React, { useRef, useEffect } from 'react';
import './HorizontalScroller.css';

const HorizontalScroller = ({ children }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      // Scroll to center on mount
      container.scrollLeft = (container.scrollWidth - container.clientWidth) / 2;
    }
  }, []);

  const scrollByAmount = (amount) => {
    const container = containerRef.current;
    if (container) {
      container.scrollBy({ left: amount, behavior: 'smooth' });
    }
  };

  const handleLeft = () => {
    const container = containerRef.current;
    if (container) {
      scrollByAmount(-container.clientWidth / 2);
    }
  };

  const handleRight = () => {
    const container = containerRef.current;
    if (container) {
      scrollByAmount(container.clientWidth / 2);
    }
  };

  return (
    <div className="horizontal-scroller-wrapper">
      {/* <button className="scroll-arrow left" onClick={handleLeft} aria-label="גלול שמאלה">&gt;</button> */}
      <div className="horizontal-scroller" ref={containerRef}>
        {children}
      </div>
      {/* <button className="scroll-arrow right" onClick={handleRight} aria-label="גלול ימינה">&lt;</button> */}
    </div>
  );
};

export default HorizontalScroller;
